import React, { useState } from "react";
import styles from "./MaelanoCampaigns.module.scss";
import DynamicCardRow from "../../../DynamicCardRow/DynamicCardRow";
import DynamicTableFilters from "../../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters";
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import { maelanoCampaignsTableData } from "../../../../../views/AdminPortal/dummyData";
import StatusBadge from "../../../../common/AdminCommonComponents/StatusBadge/StatusBadge";
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton";
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";
import CampaignCreationForm from "./CampaignCreationForm/CampaignCreationForm";

const maelanoCampaignsData = [
    { title: "Active", value: 0 },
    { title: "Scheduled Campaigns", value: 0 },
    { title: "Campaign Participation", value: 0 },
].map((item) => ({
    ...item,
    title: item.title.toUpperCase(),
}));

const MaelanoCampaigns = () => {
    const [isOpen, setIsOpen] = useState(false);

    const options = [
        { label: "View details" },
        { label: "Edit" },
        { label: "Delete" },
        { label: "Change status" },
    ];

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Media Attachment",
            cell: (row) => (
                <img src={row.imgSrc} alt="Media Image" className="img-fluid" />
            ),
            center: "true",
            width: "180px",
        },
        {
            name: "Campaign ID",
            selector: (row) => row.campaignId,
            center: "true",
            minWidth: "150px",
        },
        {
            name: "Campaign Name",
            selector: (row) => row.campaignName,
            center: "true",
            minWidth: "160px",
        },
        {
            name: "Category",
            selector: (row) => row.category,
            center: "true",
            minWidth: "120px",
        },
        {
            name: "Subdivision",
            selector: (row) => row.subDivision,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Status",
            cell: (row) => <StatusBadge statusName={row.status} />,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Start Date",
            selector: (row) => row.startDate,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "End Date",
            selector: (row) => row.endDate,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Actions",
            cell: () => <ActionButton options={options} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div className={styles.maelanoCampaignsContainer}>
            <div className={styles.orderWrapper}>
                <h5 className={styles.mainHeading}>Campaigns Overview</h5>
                <div className={styles.cardRowWrapper}>
                    <DynamicCardRow lg={4} md={12} sm={12} cards={maelanoCampaignsData} />
                </div>
            </div>

            {!isOpen ? (
                <div className={styles.filterTableWrapper}>
                    <div className={styles.headingBtnWrapper}>
                        <h5 className={styles.sectionHeading}>Campaigns</h5>
                        <DynamicButton theme="yellow" onClick={() => setIsOpen(true)}>Create New Campaign</DynamicButton>
                    </div>
                    <DynamicTableFilters
                        componentName={"Maelano Campaigns"}
                        onApply={handleApply}
                        onClear={handleClear}
                    />
                    <div className={styles.tableWrapper}>
                        <DynamicDatatable
                            data={maelanoCampaignsTableData}
                            columns={columns}
                            type="gray"
                            pagination
                            highlightOnHover
                            responsive
                        />
                    </div>
                </div>
            ) : (
                <CampaignCreationForm setIsOpen={setIsOpen} />
            )}
        </div>
    );
};

export default MaelanoCampaigns;